<template>
  <div id="page-dimension-create">
    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between mb-md-4">
      <h5 class="">{{ $t('pages.dimension.createDimension') }}</h5>
      <div>
        <router-link
            class="btn btn-outline-primary mt-2 mt-md-0"
            :to="{ name: 'dimension-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudDimension
        :dimension="dimension"
        :actionForm="'create'"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      dimension: {}
    }
  },
  components : {
    FormCrudDimension: () => import('@/components/pages/dimension/FormCrudDimension')
  }
}
</script>
